module.exports = __webpack_public_path__ + "static/media/landing-meta-image.89cf4979.png";